module.exports = __webpack_public_path__ + "img/adobe-vs-magento-img.de5a5690.webp";